import React from 'react';
import styled from 'styled-components';
import { colors } from '../utils/colors';

const Boloh3 = styled.h3`
	margin-top: 1em;
	color: ${colors.white};
	font-family: 'D-Din', sans-serif;
`;

const Bolo3 = ({ contenido }) => (
	<div>
      <Boloh3>{contenido}</Boloh3>
	</div>
);

export default Bolo3;



// WEBPACK FOOTER //
// ./src/components/Bolo3.js